@if (document) {
  <div>
    <mat-expansion-panel [expanded]="isSentToInsurerTray" class="curtains" #panel>
      <mat-expansion-panel-header [collapsedHeight]="'70px'" [expandedHeight]="'70px'">
        <mat-panel-title class="invoice-title">
          <div>
            @if (document.date) {
              <div class="received-date">
                {{ document.date | dateepoch: timezone }} {{ document.date | time: timezone }}
              </div>
            }
            <div class="invoice-number">
              <h5><span class="subtitle-1">Invoice</span> {{ invoice.invoiceNumber }}</h5>
              @if (invoice.status === 'APPROVED') {
                <div
                  (click)="$event.stopPropagation(); tooltipApprovedDate.toggle()"
                  class="invoice"
                  [appHighlightStatus]="invoice.status">
                  APPROVED
                  <div
                    #tooltipApprovedDate="matTooltip"
                    matTooltip="{{ invoice.acceptedOrRejectedDateTime | dateepoch: timezone }} {{
                      invoice.acceptedOrRejectedDateTime | time: timezone
                    }}"
                    matTooltipClass="timestamp-tooltip"></div>
                </div>
              }
              @if (invoice.status === 'ADJUSTED') {
                <div
                  (click)="$event.stopPropagation(); tooltipAdjustedDate.toggle()"
                  class="invoice"
                  [appHighlightStatus]="invoice.status">
                  ADJUSTED
                  <div
                    #tooltipAdjustedDate="matTooltip"
                    matTooltip="{{ invoice.acceptedOrRejectedDateTime | dateepoch: timezone }} {{
                      invoice.acceptedOrRejectedDateTime | time: timezone
                    }}"
                    matTooltipClass="timestamp-tooltip"></div>
                </div>
              }
              @if (invoice.status === 'REJECTED') {
                <div
                  (click)="$event.stopPropagation(); tooltipRejectedDate.toggle()"
                  class="invoice"
                  [appHighlightStatus]="invoice.status">
                  REJECTED
                  <div
                    #tooltipRejectedDate="matTooltip"
                    matTooltip="{{ invoice.acceptedOrRejectedDateTime | dateepoch: timezone }} {{
                      invoice.acceptedOrRejectedDateTime | time: timezone
                    }}"
                    matTooltipClass="timestamp-tooltip"></div>
                </div>
              }
              @if (invoice.status === 'PENDING_FOR_REVIEW') {
                <div class="invoice" [appHighlightStatus]="invoice.status">PENDING</div>
              }
            </div>
          </div>
          <div>
            <div class="body-2">Invoiced Parts</div>
            <div class="data-values subtitle-2">$ {{ invoice.amountPartTotalInvoiced | number: '1.2-2' }}</div>
          </div>
          <div>
            <div class="body-2">Invoiced Labour</div>
            <div class="data-values subtitle-2">$ {{ invoice.amountLabourTotalInvoiced | number: '1.2-2' }}</div>
          </div>
          <div>
            <div class="body-2">Invoiced Sublet</div>
            <div class="data-values subtitle-2">$ {{ invoice.amountSubletInvoiced | number: '1.2-2' }}</div>
          </div>
          <div>
            <div class="body-2">Total Invoiced</div>
            <div class="data-values subtitle-2">$ {{ invoice.amountTotalIncludingTaxInvoiced | number: '1.2-2' }}</div>
          </div>
        </mat-panel-title>
        <mat-panel-description class="kebab-panel">
          @if (invoice.status !== 'CREATED') {
            <div class="secondary-icon">
              @if (!loadingPDF) {
                <pdf-button (openPDF)="openInvoiceReport()" />
              }
              @if (loadingPDF) {
                <div class="section-container-spinner w-[32px]">
                  <mat-spinner mode="indeterminate" [diameter]="24"></mat-spinner>
                </div>
              }
            </div>
          }
          @if (invoice.status === 'PENDING_FOR_REVIEW') {
            <div class="secondary-icon">
              <button
                matIconButton
                [matMenuTriggerData]="{ invoiceId: invoice?.id }"
                [matMenuTriggerFor]="kebabMenu"
                (click)="$event.stopPropagation()">
                <mat-icon>more_vert_32px</mat-icon>
              </button>
            </div>
          }
          <div class="secondary-icon">
            @if (!document.submitted && invoice.status === 'CREATED') {
              <button matIconButton (click)="$event.stopPropagation(); confirmDeleteInvoice(invoice.id, invoice.jobId)">
                <mat-icon>delete</mat-icon>
              </button>
            }
          </div>
        </mat-panel-description>
      </mat-expansion-panel-header>
      <mat-divider />
      <form [formGroup]="invoiceForm">
        <div class="invoice-fields-grid">
          <mat-form-field class="primary-icon">
            <mat-label>Invoice Number</mat-label>
            <input formControlName="invoiceNumber" matInput required />
            @if (invoiceNumber.hasError('required')) {
              <mat-error> Invoice Number is <strong>required</strong> </mat-error>
            }
            @if (invoiceNumber.hasError('duplicateInvoice')) {
              <mat-error> This invoice number is already associated with this job </mat-error>
            }
          </mat-form-field>
          <mat-form-field class="two-columns">
            <mat-label>Prepared By</mat-label>
            <input (change)="update('preparedBy')" formControlName="preparedBy" matInput />
          </mat-form-field>
          @if (
            invoice.status !== 'CREATED' && invoice.status !== 'PENDING_FOR_REVIEW' && invoice.costControllerComment
          ) {
            <div class="three-columns">
              <span class="body-2">Cost controller Comment</span>
              <div class="cost-control-comment subtitle-2">{{ invoice.costControllerComment }}</div>
            </div>
          }
        </div>
        @if (
          usingFactoringCompany() ||
          (!['NOT_USING_FLIP_MONEY'].includes(invoice.estimagePayPaymentRequestStatus) &&
            !(totalPayable > invoice?.estimagePayMaxAmount && document.submitted))
        ) {
          <div class="three-columns invoice-section mb-10">
            <h4>Invoice</h4>
            <mat-divider />
          </div>
        }
        <div class="flex flex-col gap-20 justify-center items-center pb-20">
          <div class="flex gap-20">
            @if (
              !document.submitted ||
              (['NOT_USING_FLIP_MONEY'].includes(invoice.estimagePayPaymentRequestStatus) && !usingFactoringCompany())
            ) {
              <infos-card class="w-[580px]" [title]="bankingDetailsBanner().repairerName">
                <div class="grid gap-10" card-body-content>
                  @if (
                    bankingDetailsBanner().bsb ||
                    bankingDetailsBanner().accountName ||
                    bankingDetailsBanner().accountNumber
                  ) {
                    <div class="grid grid-cols-4 gap-5">
                      <ng-template
                        [ngTemplateOutlet]="infosContent"
                        [ngTemplateOutletContext]="{
                          field: invoice.repairerCountry === 'Australia' ? 'ABN' : 'NZBN',
                          value: bankingDetailsBanner().repairerAbn
                        }" />
                      <ng-template
                        [ngTemplateOutlet]="infosContent"
                        [ngTemplateOutletContext]="{ field: 'BSB', value: bankingDetailsBanner().bsb }" />
                      <ng-template
                        [ngTemplateOutlet]="infosContent"
                        [ngTemplateOutletContext]="{
                          field: 'Account Name',
                          value: bankingDetailsBanner().accountName
                        }" />
                      <ng-template
                        [ngTemplateOutlet]="infosContent"
                        [ngTemplateOutletContext]="{
                          field: 'Account No',
                          value: bankingDetailsBanner().accountNumber
                        }" />
                    </div>
                  } @else {
                    <div class="flex justify-between items-center">
                      @if (
                        !bankingDetailsBanner().bsb &&
                        (currentUser.privileges.includes('SYSADMIN') || currentUser.privileges.includes('REPADMIN'))
                      ) {
                        <button
                          matButton="elevated"
                          type="button"
                          class="charcoal-button"
                          (click)="addBankingDetails()"
                          [disabled]="document.submitted">
                          ADD BANKING DETAILS
                        </button>
                      }
                      @if (!usingFactoringCompany()) {
                        <div>
                          @if (
                            (!document.submitted && !invoice.bsb) || (document.submitted && invoice.paymentByCheque)
                          ) {
                            <mat-checkbox
                              #bankingCheckbox
                              (change)="setPaymentByCheque(bankingCheckbox.checked)"
                              [checked]="paymentByCheque"
                              [disabled]="document.submitted">
                              Request payment by cheque
                            </mat-checkbox>
                          }
                        </div>
                      }
                    </div>
                    @if (!bankingDetailsBanner().bsb && !currentUser.privileges.length) {
                      <infos-guidance [guidanceTemplate]="noBankingGuidance" />
                    }
                  }
                  <mat-tab-group animationDuration="0ms" class="icon-tabs" disablePagination>
                    @if (invoice?.repairerAddress) {
                      <mat-tab>
                        <ng-template mat-tab-label>
                          <mat-icon class="size-18! text-18!">pin_drop</mat-icon>
                        </ng-template>
                        <div class="body-1 mt-5 min-h-20 break-all">
                          <span class="body-2 text-charcoal-60 pr-10">Address</span> {{ invoice.repairerAddress }}
                        </div>
                      </mat-tab>
                    }
                    @if (invoice?.repairerEmail) {
                      <mat-tab>
                        <ng-template mat-tab-label>
                          <mat-icon class="size-18! text-18!">email</mat-icon>
                        </ng-template>
                        <div class="body-1 mt-5 min-h-20 break-all">
                          <span class="body-2 text-charcoal-60 pr-10">Email</span> {{ invoice.repairerEmail }}
                        </div>
                      </mat-tab>
                    }
                    @if (invoice?.repairerPhone) {
                      <mat-tab>
                        <ng-template mat-tab-label>
                          <mat-icon class="size-18! text-18!">phone</mat-icon>
                        </ng-template>
                        <div class="body-1 mt-5 min-h-20 break-all">
                          <span class="body-2 text-charcoal-60 pr-10">Phone</span> {{ invoice.repairerPhone }}
                        </div>
                      </mat-tab>
                    }
                  </mat-tab-group>
                </div>
              </infos-card>
            }
            @if (!document.submitted) {
              @if (sysAdminService.estimagePayEnabled()) {
                <mat-card class="p-10! h-full">
                  <img ngSrc="assets/images/estimage_pay_banner.svg" alt="Estimage Pay" width="320" height="100" />
                  <div class="flex flex-col justify-between gap-5 h-full">
                    <div class="subtitle-2 italic">Get paid today with no additional steps!</div>
                    <div
                      [matTooltip]="
                        !invoice.estimagePayAllowed
                          ? !(currentUser?.privileges && currentUser?.privileges?.includes('REPADMIN'))
                            ? 'Ask your administrator about applying for EstImage Pay'
                            : 'Apply to use EstImage Pay in your EstImage Pay page'
                          : 'The total payable amount is greater than the maximum amount supported by EstImage Pay (' +
                            (invoice.estimagePayMaxAmount | number: '1.2-2') +
                            '$)'
                      "
                      [matTooltipDisabled]="invoice.estimagePayAllowed && totalPayable <= invoice.estimagePayMaxAmount">
                      <button
                        matButton="elevated"
                        type="button"
                        class="charcoal-button w-full"
                        [disabled]="
                          !invoice.estimagePayAllowed ||
                          totalPayable > invoice.estimagePayMaxAmount ||
                          !['NOT_USING_FLIP_MONEY'].includes(invoice.estimagePayPaymentRequestStatus) ||
                          !!selectedFactoringCompany()
                        "
                        (click)="useEstimagePay()">
                        <mat-icon class="size-18! text-18! mr-[7px]" svgIcon="estimage_pay" />
                        <span>USE ESTIMAGE PAY</span>
                      </button>
                    </div>
                  </div>
                </mat-card>
              }
              <div class="flex flex-col gap-20 justify-center items-center w-min">
                <button
                  matButton="elevated"
                  type="button"
                  class="white-button w-[300px]"
                  (click)="useFactoringCompany()"
                  [disabled]="
                    usingFactoringCompany() ||
                    !['NOT_USING_FLIP_MONEY'].includes(invoice.estimagePayPaymentRequestStatus)
                  ">
                  USE FACTORING COMPANY*
                </button>
                <div class="body-2 text-center">*Some additional steps may be required outside of EstImage</div>
              </div>
            }
          </div>
          <div class="flex flex-col gap-20 w-[1200px] place-items-center">
            @if (
              !['NOT_USING_FLIP_MONEY'].includes(invoice.estimagePayPaymentRequestStatus) &&
              !(totalPayable > invoice?.estimagePayMaxAmount && document.submitted)
            ) {
              <estimage-pay-guidance
                [invoice]="invoice"
                [totalPayable]="totalPayable"
                [submitted]="document.submitted"
                (useEstimagePay)="useEstimagePay()" />
            }
            @if (usingFactoringCompany()) {
              <factoring-company-guidance
                [invoice]="invoice"
                [submitted]="document.submitted"
                (useFactoringCompany)="useFactoringCompany()"
                (removeFactoringCompany)="removeFactoringCompany()" />
            }
          </div>
        </div>
        <h4 class="overview-titles">Overview</h4>
        <div class="overview-grid">
          <div>
            <div class="body-2">Labour</div>
            <div class="overview-amounts body-1">
              $
              <div class="section-amount subtitle-2">{{ invoice.amountLabourTotalInvoiced | number: '1.2-2' }}</div>
              <ng-container
                [ngTemplateOutletContext]="{
                  assessedAmount: invoice.amountLabourTotalAssessed,
                  invoicedAmount: invoice.amountLabourTotalInvoiced
                }"
                [ngTemplateOutlet]="overviewTotals"></ng-container>
            </div>
          </div>
          <div>
            <div class="body-2">Parts</div>
            <div class="overview-amounts body-1">
              $
              <div class="section-amount subtitle-2">{{ invoice.amountPartTotalInvoiced | number: '1.2-2' }}</div>
              <ng-container
                [ngTemplateOutletContext]="{
                  assessedAmount: invoice.amountPartTotalAssessed,
                  invoicedAmount: invoice.amountPartTotalInvoiced
                }"
                [ngTemplateOutlet]="overviewTotals"></ng-container>
            </div>
          </div>
          <div>
            <div class="body-2">Sublet</div>
            <div class="overview-amounts body-1">
              $
              <div class="section-amount subtitle-2">{{ invoice.amountSubletInvoiced | number: '1.2-2' }}</div>
              <ng-container
                [ngTemplateOutletContext]="{
                  assessedAmount: invoice.amountSubletAssessed,
                  invoicedAmount: invoice.amountSubletInvoiced
                }"
                [ngTemplateOutlet]="overviewTotals"></ng-container>
            </div>
          </div>
          <div>
            <div class="body-2 black-high">Subtotal</div>
            <div class="overview-amounts body-1">
              $
              <div class="subtotal-amount subtitle-2">
                {{ invoice.amountTotalExcludingTaxInvoiced | number: '1.2-2' }}
              </div>
            </div>
          </div>
          <div>
            <div class="body-2 black-high">GST</div>
            <div class="overview-amounts body-1">
              $
              <div class="subtotal-amount subtitle-2">{{ invoice.amountTaxInvoiced | number: '1.2-2' }}</div>
            </div>
          </div>
          <div>
            <div class="body-2 black-high">Total</div>
            <div class="overview-amounts body-1">
              $
              <div class="total-amount subtitle-2">{{ invoice.amountTotalIncludingTaxInvoiced | number: '1.2-2' }}</div>
              <ng-container
                [ngTemplateOutletContext]="{
                  assessedAmount: invoice.amountTotalIncludingTaxAssessed,
                  invoicedAmount: invoice.amountTotalIncludingTaxInvoiced
                }"
                [ngTemplateOutlet]="overviewTotals"></ng-container>
            </div>
          </div>
        </div>
        @if (invoice.status === 'ADJUSTED') {
          <h4 class="overview-titles">Approved</h4>
          <div class="overview-grid">
            <div>
              <div class="body-2">Labour</div>
              <div class="overview-amounts body-1">
                $
                <div class="section-amount subtitle-2">{{ invoice.amountLabourTotalAccepted | number: '1.2-2' }}</div>
                <ng-container
                  [ngTemplateOutletContext]="{
                    assessedAmount: invoice.amountLabourTotalInvoiced,
                    invoicedAmount: invoice.amountLabourTotalAccepted
                  }"
                  [ngTemplateOutlet]="overviewTotals"></ng-container>
              </div>
            </div>
            <div>
              <div class="body-2">Parts</div>
              <div class="overview-amounts body-1">
                $
                <div class="section-amount subtitle-2">{{ invoice.amountPartTotalAccepted | number: '1.2-2' }}</div>
                <ng-container
                  [ngTemplateOutletContext]="{
                    assessedAmount: invoice.amountPartTotalInvoiced,
                    invoicedAmount: invoice.amountPartTotalAccepted
                  }"
                  [ngTemplateOutlet]="overviewTotals"></ng-container>
              </div>
            </div>
            <div>
              <div class="body-2">Sublet</div>
              <div class="overview-amounts body-1">
                $
                <div class="section-amount subtitle-2">{{ invoice.amountSubletAccepted | number: '1.2-2' }}</div>
                <ng-container
                  [ngTemplateOutletContext]="{
                    assessedAmount: invoice.amountSubletInvoiced,
                    invoicedAmount: invoice.amountSubletAccepted
                  }"
                  [ngTemplateOutlet]="overviewTotals"></ng-container>
              </div>
            </div>
            <div>
              <div class="body-2 black-high">Subtotal</div>
              <div class="overview-amounts body-1">
                $
                <div class="subtotal-amount subtitle-2">
                  {{ invoice.amountTotalExcludingTaxAccepted | number: '1.2-2' }}
                </div>
              </div>
            </div>
            <div>
              <div class="body-2 black-high">GST</div>
              <div class="overview-amounts body-1">
                $
                <div class="subtotal-amount subtitle-2">{{ invoice.amountTaxAccepted | number: '1.2-2' }}</div>
              </div>
            </div>
            <div>
              <div class="body-2 black-high">Total</div>
              <div class="overview-amounts body-1">
                $
                <div class="total-amount subtitle-2">
                  {{ invoice.amountTotalIncludingTaxAccepted | number: '1.2-2' }}
                </div>
                <ng-container
                  [ngTemplateOutletContext]="{
                    assessedAmount: invoice.amountTotalIncludingTaxInvoiced,
                    invoicedAmount: invoice.amountTotalIncludingTaxAccepted
                  }"
                  [ngTemplateOutlet]="overviewTotals"></ng-container>
              </div>
            </div>
          </div>
        }
        <mat-divider />
        <div class="overview-grid" [ngClass]="invoice.isFirstInvoice ? 'overview-payable-line' : 'only-payable-total'">
          @if (invoice.isFirstInvoice) {
            <div>
              @if (lastExcessChangeTimestamp) {
                <div class="info-guidance subtitle-2">
                  <mat-icon>info_outlined</mat-icon>
                  <span
                    >Please be advised that the excess value changed on
                    {{ lastExcessChangeTimestamp | dateepoch: timezone }}
                    {{ lastExcessChangeTimestamp | time: timezone }}</span
                  >
                </div>
              }
            </div>
            <div>
              <div class="body-2">Less Excess</div>
              <div class="overview-amounts body-1">
                @if (!invoice.excessType) {
                  $
                }
                <div class="subtotal-amount">
                  {{ !invoice.excessType ? (invoice.excess | number: '1.2-2') : invoice.excessType }}
                </div>
              </div>
            </div>
            <div class="owner-contribution">
              <mat-form-field>
                <mat-label>Owner Contribution</mat-label>
                <input (blur)="formatOwnerContribution()" formControlName="ownerContribution" matInput />
                @if (invoiceForm.controls.ownerContribution.value) {
                  <mat-icon matSuffix>attach_money_24px</mat-icon>
                }
                @if (!invoiceForm.controls.ownerContribution.valid) {
                  <mat-error> Enter number</mat-error>
                }
              </mat-form-field>
            </div>
          }
          @if (invoice.status !== 'REJECTED') {
            <div>
              <div class="body-2 black-high">Total Payable</div>
              <div class="overview-amounts body-1">
                $
                <div class="total-amount">
                  <div class="title-1">{{ totalPayable | number: '1.2-2' }}</div>
                </div>
              </div>
            </div>
          }
        </div>
        <div class="inline-flex subtitle-1 text-red font-bold">
          <mat-icon class="mx-10 text-red!"> warning </mat-icon>
          NO ACTION WILL BE TAKEN REGARDING COMMENTS CONCERNING FACTORED INVOICES, YOUR AGREEMENT ALLOWS USE OF THE
          PLATFORM AS PROVIDED
        </div>
        <mat-form-field>
          <mat-label>Repairer Comments</mat-label>
          <textarea
            matInput
            formControlName="repairerComment"
            cdkAutosizeMinRows="3"
            maxlength="65535"
            cdkTextareaAutosize="true"></textarea>
        </mat-form-field>
        @if (invoice.labour?.length) {
          <div class="invoice-table" formArrayName="labourItems">
            <h4 class="section-header">Labour</h4>
            <table [dataSource]="labourDataSource" class="table-style" mat-table>
              <ng-container matColumnDef="description">
                <th *matHeaderCellDef class="text-14!" mat-header-cell>Description</th>
                <td *matCellDef="let item" mat-cell>
                  <div class="flex items-center" [class.ml-30]="atLeastOneComment && !item?.costControlComment">
                    <ng-container
                      *ngTemplateOutlet="
                        comment;
                        context: { costControlComment: item?.costControlComment }
                      "></ng-container>
                    @switch (item.labourType) {
                      @case ('RR') {
                        <span>Remove & Replace</span>
                      }
                      @case ('REP') {
                        <span>Repair</span>
                      }
                      @case ('PAINT') {
                        <span>Paint</span>
                      }
                      @case ('MEC') {
                        <span>Mechanical</span>
                      }
                      @case ('MISC') {
                        <span>Miscellaneous</span>
                      }
                    }
                    @if (item.groupName) {
                      <span class="labour-group">{{ item.groupName }}</span>
                    }
                  </div>
                </td>
                <td *matFooterCellDef class="footer-label" mat-footer-cell>Labour Total</td>
              </ng-container>
              <ng-container matColumnDef="assessedAmount">
                <th *matHeaderCellDef class="text-14!" mat-header-cell>Assessed</th>
                <td *matCellDef="let item" mat-cell>
                  @if (item.assessedAmount || item.assessedAmount === 0) {
                    <div class="amount-cell">
                      <div class="sign-cell">$</div>
                      {{ item.assessedAmount | number: '1.2-2' }}
                    </div>
                  }
                </td>
                <td *matFooterCellDef mat-footer-cell>
                  <div class="amount-cell">
                    <div class="sign-cell">$</div>
                    {{ invoice.amountLabourTotalAssessed | number: '1.2-2' }}
                  </div>
                </td>
              </ng-container>
              <ng-container matColumnDef="invoicedAmount">
                <th *matHeaderCellDef class="padding-right-10 text-14!" mat-header-cell>Invoiced</th>
                <td *matCellDef="let item" mat-cell>
                  @if (item.invoicedAmount || item.invoicedAmount === 0) {
                    <div class="assess-indicator">
                      <mat-form-field subscriptSizing="dynamic" class="invoice-column-field sm no-label">
                        <input
                          (change)="updateLabour(item.id)"
                          [formControl]="labourItems | getControl: item.id"
                          class="body-1"
                          matInput />
                        <div class="prefix body-1" matTextPrefix>$</div>
                        <mat-error>Enter number</mat-error>
                      </mat-form-field>
                      <ng-container
                        [ngTemplateOutletContext]="{
                          assessedAmount: item.assessedAmount,
                          invoicedAmount: item.invoicedAmount
                        }"
                        [ngTemplateOutlet]="differenceIndicators"></ng-container>
                    </div>
                  }
                </td>
                <td *matFooterCellDef class="padding-right-12" mat-footer-cell>
                  <div class="amount-cell">
                    <div class="sign-cell">$</div>
                    {{ invoice.amountLabourTotalInvoiced | number: '1.2-2' }}
                  </div>
                </td>
              </ng-container>
              <ng-container matColumnDef="approvedAmount">
                <th *matHeaderCellDef class="text-14!" mat-header-cell>Approved</th>
                <td *matCellDef="let item" mat-cell>
                  <div [class.indicator-approved]="item.approvedAmount" class="assess-indicator">
                    @if (item.approvedAmount || item.approvedAmount === 0) {
                      <div class="amount-cell">
                        <div class="sign-cell">$</div>
                        {{ item.approvedAmount | number: '1.2-2' }}
                      </div>
                      <ng-container
                        [ngTemplateOutletContext]="{
                          approvedAmount: item.approvedAmount,
                          invoicedAmount: item.invoicedAmount
                        }"
                        [ngTemplateOutlet]="differenceIndicatorsApproved"></ng-container>
                    }
                  </div>
                </td>
                <td *matFooterCellDef mat-footer-cell>
                  @if (invoice.amountLabourTotalAccepted) {
                    <div class="amount-cell">
                      <div class="sign-cell">$</div>
                      {{ invoice.amountLabourTotalAccepted | number: '1.2-2' }}
                    </div>
                  }
                </td>
              </ng-container>
              <tr *matHeaderRowDef="labourColumnHeaders" mat-header-row></tr>
              <tr *matRowDef="let item; let even = even; columns: labourColumnHeaders" mat-row></tr>
              <tr *matFooterRowDef="labourColumnHeaders" mat-footer-row></tr>
              <!-- Group header -->
              <ng-container matColumnDef="groupHeader">
                <td *matCellDef="let groupBy" colspan="999" mat-cell>
                  <div class="subtitle-2">
                    {{ groupBy.quoteVersion }} <span class="subtitle-2">{{ groupBy.quoteNumber }}</span>
                  </div>
                </td>
              </ng-container>
              <tr *matRowDef="let row; columns: ['groupHeader']; when: isGroup" class="group-row" mat-row></tr>
            </table>
          </div>
        }
        @if (invoice.parts?.length) {
          <div class="invoice-table" formArrayName="partItems">
            <h4 class="section-header">Parts</h4>
            <table [dataSource]="partDataSource" class="table-style" mat-table>
              @if (!isLargeScreen) {
                <ng-container matColumnDef="partDescriptionNumber">
                  <th *matHeaderCellDef class="text-14!" mat-header-cell>
                    <div>Description / Part Number</div>
                  </th>
                  <td *matCellDef="let item" mat-cell>
                    <div class="flex items-center" [class.ml-30]="atLeastOneComment && !item?.costControlComment">
                      <ng-container
                        *ngTemplateOutlet="
                          comment;
                          context: { costControlComment: item?.costControlComment }
                        "></ng-container>
                      <div>{{ item.description }}</div>
                      <div>{{ item.partNumber }}</div>
                    </div>
                  </td>
                  <td *matFooterCellDef mat-footer-cell></td>
                </ng-container>
              }
              @if (isLargeScreen) {
                <ng-container matColumnDef="partDescription">
                  <th *matHeaderCellDef class="text-14!" mat-header-cell>Description</th>
                  <td *matCellDef="let item" mat-cell>
                    <div class="flex items-center" [class.ml-30]="atLeastOneComment && !item?.costControlComment">
                      <ng-container
                        *ngTemplateOutlet="
                          comment;
                          context: { costControlComment: item?.costControlComment }
                        "></ng-container>
                      <div>{{ item.description }}</div>
                    </div>
                  </td>
                  <td *matFooterCellDef mat-footer-cell></td>
                </ng-container>
                <ng-container matColumnDef="partNumber">
                  <th *matHeaderCellDef class="text-14!" mat-header-cell>Part Number</th>
                  <td *matCellDef="let item" mat-cell>{{ item.partNumber }}</td>
                  <td *matFooterCellDef mat-footer-cell></td>
                </ng-container>
              }
              <ng-container matColumnDef="partSource">
                <th *matHeaderCellDef class="text-14!" mat-header-cell>Part Source</th>
                <td *matCellDef="let item" mat-cell>{{ item.partSource }}</td>
                <td *matFooterCellDef mat-footer-cell></td>
              </ng-container>
              <ng-container matColumnDef="assessorNote">
                <th *matHeaderCellDef class="text-14!" mat-header-cell>Assessor Note</th>
                <td *matCellDef="let item" mat-cell>
                  <div>{{ item.assessorNote }}</div>
                </td>
                <td *matFooterCellDef class="footer-label" mat-footer-cell>Parts Total</td>
              </ng-container>
              <ng-container matColumnDef="assessedAmount">
                <th *matHeaderCellDef class="text-14!" mat-header-cell>Assessed</th>
                <td *matCellDef="let item" mat-cell>
                  @if (item.assessedAmount || item.assessedAmount === 0) {
                    <div class="amount-cell">
                      <div class="sign-cell">$</div>
                      {{ item.assessedAmount | number: '1.2-2' }}
                    </div>
                  }
                </td>
                <td *matFooterCellDef mat-footer-cell>
                  <div class="amount-cell">
                    <div class="sign-cell">$</div>
                    {{ invoice.amountPartTotalAssessed | number: '1.2-2' }}
                  </div>
                </td>
              </ng-container>
              <ng-container matColumnDef="invoicedAmount">
                <th *matHeaderCellDef class="padding-right-10 text-14!" mat-header-cell>Invoiced</th>
                <td *matCellDef="let item" mat-cell>
                  @if (item.invoicedAmount || item.invoicedAmount === 0) {
                    <div class="assess-indicator">
                      <mat-form-field subscriptSizing="dynamic" class="invoice-column-field sm no-label">
                        <input
                          (change)="updateParts(item.id)"
                          [formControl]="partItems | getControl: item.id"
                          class="body-1"
                          matInput />
                        <div class="prefix body-1" matTextPrefix>$</div>
                        <mat-error>Enter number</mat-error>
                      </mat-form-field>
                      <ng-container
                        [ngTemplateOutletContext]="{
                          assessedAmount: item.assessedAmount,
                          invoicedAmount: item.invoicedAmount
                        }"
                        [ngTemplateOutlet]="differenceIndicators"></ng-container>
                    </div>
                  }
                </td>
                <td *matFooterCellDef class="padding-right-12" mat-footer-cell>
                  <div class="amount-cell">
                    <div class="sign-cell">$</div>
                    {{ invoice.amountPartTotalInvoiced | number: '1.2-2' }}
                  </div>
                </td>
              </ng-container>
              <ng-container matColumnDef="approvedAmount">
                <th *matHeaderCellDef class="text-14!" mat-header-cell>Approved</th>
                <td *matCellDef="let item" mat-cell>
                  <div [class.indicator-approved]="item.approvedAmount" class="assess-indicator">
                    @if (item.approvedAmount || item.approvedAmount === 0) {
                      <div class="amount-cell">
                        <div class="sign-cell">$</div>
                        {{ item.approvedAmount | number: '1.2-2' }}
                      </div>
                      <ng-container
                        [ngTemplateOutletContext]="{
                          approvedAmount: item.approvedAmount,
                          invoicedAmount: item.invoicedAmount
                        }"
                        [ngTemplateOutlet]="differenceIndicatorsApproved"></ng-container>
                    }
                  </div>
                </td>
                <td *matFooterCellDef mat-footer-cell>
                  @if (invoice.amountPartTotalAccepted) {
                    <div class="amount-cell">
                      <div class="sign-cell">$</div>
                      {{ invoice.amountPartTotalAccepted | number: '1.2-2' }}
                    </div>
                  }
                </td>
              </ng-container>
              <tr *matHeaderRowDef="partColumnHeaders" mat-header-row></tr>
              <tr *matRowDef="let item; let even = even; columns: partColumnHeaders" mat-row></tr>
              <tr *matFooterRowDef="partColumnHeaders" mat-footer-row></tr>
              <!-- Group header -->
              <ng-container matColumnDef="groupHeader">
                <td *matCellDef="let groupBy" colspan="999" mat-cell>
                  <div class="subtitle-2">
                    {{ groupBy.quoteVersion }} <span class="subtitle-2">{{ groupBy.quoteNumber }}</span>
                  </div>
                </td>
              </ng-container>
              <tr *matRowDef="let row; columns: ['groupHeader']; when: isGroup" class="group-row" mat-row></tr>
            </table>
          </div>
        }
        @if (invoice.sublets?.length) {
          <div class="invoice-table" formArrayName="subletItems">
            <h4 class="section-header">Sublets</h4>
            <table [dataSource]="subletsDataSource" class="table-style" mat-table>
              <ng-container matColumnDef="description">
                <th *matHeaderCellDef class="text-14!" mat-header-cell>Description</th>
                <td *matCellDef="let item" mat-cell>
                  <div class="flex items-center" [class.ml-30]="atLeastOneComment && !item?.costControlComment">
                    <ng-container
                      *ngTemplateOutlet="
                        comment;
                        context: { costControlComment: item?.costControlComment }
                      "></ng-container>
                    <div>{{ item.description }}</div>
                  </div>
                </td>
                <td *matFooterCellDef mat-footer-cell></td>
              </ng-container>
              <ng-container matColumnDef="note">
                <th *matHeaderCellDef class="text-14!" mat-header-cell>Assessor Note</th>
                <td *matCellDef="let item" mat-cell>
                  <div>{{ item.assessorNote }}</div>
                </td>
                <td *matFooterCellDef class="footer-label" mat-footer-cell>Sublets Total</td>
              </ng-container>
              <ng-container matColumnDef="assessedAmount">
                <th *matHeaderCellDef class="text-14!" mat-header-cell>Assessed</th>
                <td *matCellDef="let item" mat-cell>
                  @if (item.assessedAmount || item.assessedAmount === 0) {
                    <div class="amount-cell">
                      <div class="sign-cell">$</div>
                      {{ item.assessedAmount | number: '1.2-2' }}
                    </div>
                  }
                </td>
                <td *matFooterCellDef mat-footer-cell>
                  <div class="amount-cell">
                    <div class="sign-cell">$</div>
                    {{ invoice.amountSubletAssessed | number: '1.2-2' }}
                  </div>
                </td>
              </ng-container>
              <ng-container matColumnDef="invoicedAmount">
                <th *matHeaderCellDef class="padding-right-10 text-14!" mat-header-cell>Invoiced</th>
                <td *matCellDef="let item" mat-cell>
                  <div class="assess-indicator">
                    @if (item.invoicedAmount || item.invoicedAmount === 0) {
                      <mat-form-field subscriptSizing="dynamic" class="invoice-column-field sm no-label">
                        <input
                          (change)="updateSublet(item.id)"
                          [formControl]="subletItems | getControl: item.id"
                          class="body-1"
                          matInput />
                        <div class="prefix body-1" matTextPrefix>$</div>
                        <mat-error>Enter number</mat-error>
                      </mat-form-field>
                      <ng-container
                        [ngTemplateOutletContext]="{
                          assessedAmount: item.assessedAmount,
                          invoicedAmount: item.invoicedAmount
                        }"
                        [ngTemplateOutlet]="differenceIndicators"></ng-container>
                    }
                  </div>
                </td>
                <td *matFooterCellDef class="padding-right-12" mat-footer-cell>
                  <div class="amount-cell">
                    <div class="sign-cell">$</div>
                    {{ invoice.amountSubletInvoiced | number: '1.2-2' }}
                  </div>
                </td>
              </ng-container>
              <ng-container matColumnDef="approvedAmount">
                <th *matHeaderCellDef class="text-14!" mat-header-cell>Approved</th>
                <td *matCellDef="let item" mat-cell>
                  <div [class.indicator-approved]="item.approvedAmount" class="assess-indicator">
                    @if (item.approvedAmount || item.approvedAmount === 0) {
                      <div class="amount-cell">
                        <div class="sign-cell">$</div>
                        {{ item.approvedAmount | number: '1.2-2' }}
                      </div>
                      <ng-container
                        [ngTemplateOutletContext]="{
                          approvedAmount: item.approvedAmount,
                          invoicedAmount: item.invoicedAmount
                        }"
                        [ngTemplateOutlet]="differenceIndicatorsApproved"></ng-container>
                    }
                  </div>
                </td>
                <td *matFooterCellDef mat-footer-cell>
                  @if (invoice.amountSubletAccepted) {
                    <div class="amount-cell">
                      <div class="sign-cell">$</div>
                      {{ invoice.amountSubletAccepted | number: '1.2-2' }}
                    </div>
                  }
                </td>
              </ng-container>
              <tr *matHeaderRowDef="subletsColumnHeaders" mat-header-row></tr>
              <tr *matRowDef="let item; let even = even; columns: subletsColumnHeaders" mat-row></tr>
              <tr *matFooterRowDef="subletsColumnHeaders" mat-footer-row></tr>
              <!-- Group header -->
              <ng-container matColumnDef="groupHeader">
                <td *matCellDef="let groupBy" colspan="999" mat-cell>
                  <div class="subtitle-2">
                    {{ groupBy.quoteVersion }} <span class="subtitle-2">{{ groupBy.quoteNumber }}</span>
                  </div>
                </td>
              </ng-container>
              <tr *matRowDef="let row; columns: ['groupHeader']; when: isGroup" class="group-row" mat-row></tr>
            </table>
          </div>
        }
      </form>
    </mat-expansion-panel>
  </div>
}

<ng-template #overviewTotals let-assessedAmount="assessedAmount" let-invoicedAmount="invoicedAmount">
  <div class="assess-indicator">
    <div
      [ngClass]="{
        ASSESSED_UNDER: assessedAmount !== invoicedAmount,
        ASSESSED_EQUAL: assessedAmount === invoicedAmount
      }"
      class="indicator margin-left-10">
      @if (invoicedAmount < assessedAmount) {
        <mat-icon>keyboard_arrow_down</mat-icon>
      }
      @if (invoicedAmount > assessedAmount) {
        <mat-icon>keyboard_arrow_up</mat-icon>
      }
      @if (assessedAmount === invoicedAmount) {
        <mat-icon>check</mat-icon>
      }
    </div>
  </div>
  @if (assessedAmount !== invoicedAmount) {
    <span class="overview-diff body-2"
      >$
      @if (invoicedAmount < assessedAmount) {
        <span> - </span>
      }
      @if (invoicedAmount > assessedAmount) {
        <span> + </span>
      }
      {{ Math.abs(invoicedAmount - assessedAmount) | number: '1.2-2' }}
    </span>
  }
</ng-template>

<ng-template #differenceIndicators let-assessedAmount="assessedAmount" let-invoicedAmount="invoicedAmount">
  <div class="assess-indicator">
    <div
      [ngClass]="{
        ASSESSED_UNDER: assessedAmount !== invoicedAmount && invoicedAmount !== 0,
        ASSESSED_REJECTED: invoicedAmount === 0 && assessedAmount !== 0
      }"
      class="indicator margin-left-10">
      @if (invoicedAmount && invoicedAmount < assessedAmount) {
        <mat-icon>keyboard_arrow_down</mat-icon>
      }
      @if (invoicedAmount > assessedAmount) {
        <mat-icon>keyboard_arrow_up</mat-icon>
      }
      @if (invoicedAmount === 0 && assessedAmount !== 0) {
        <mat-icon>clear</mat-icon>
      }
    </div>
  </div>
</ng-template>

<ng-template #differenceIndicatorsApproved let-approvedAmount="approvedAmount" let-invoicedAmount="invoicedAmount">
  <div class="assess-indicator">
    <div
      [ngClass]="{ ASSESSED_UNDER: approvedAmount !== invoicedAmount && approvedAmount !== 0 }"
      class="indicator margin-left-10">
      @if (approvedAmount && approvedAmount < invoicedAmount) {
        <mat-icon>keyboard_arrow_down</mat-icon>
      }
      @if (approvedAmount > invoicedAmount) {
        <mat-icon>keyboard_arrow_up</mat-icon>
      }
    </div>
  </div>
</ng-template>

<mat-menu #kebabMenu="matMenu" [xPosition]="'before'" class="job-progress">
  <ng-template let-invoiceId="invoiceId" matMenuContent>
    <button
      (click)="cancelInvoice(invoiceId)"
      [disabled]="document.submitted && userService.isRepairerSiteSuspended()"
      mat-menu-item>
      Cancel Invoice
    </button>
  </ng-template>
</mat-menu>

<ng-template #comment let-costControlComment="costControlComment">
  @if (costControlComment) {
    <mat-icon
      [matTooltip]="costControlComment"
      matTooltipPosition="below"
      class="size-18! text-18! mr-10"
      svgIcon="chat_black_notification"></mat-icon>
  }
</ng-template>

<ng-template #infosContent let-field="field" let-value="value">
  @if (value) {
    <infos-content [field]="field" [value]="value" />
  }
</ng-template>

<ng-template #noBankingGuidance>
  <div class="subtitle-2">Please ask the administrator to complete the banking details.</div>
</ng-template>
